export enum CognitoCodes {
  USER_NOT_FOUND = 'UserNotFoundException',
  LIMIT_EXCEEDED = 'LimitExceededException',
  NOT_AUTHORIZED = 'NotAuthorizedException',
  CODE_MISMATCH = 'CodeMismatchException',
}
export const getErrorMessage = (code: CognitoCodes): string => {
  switch (code) {
    case CognitoCodes.USER_NOT_FOUND:
      return 'There is not an account associated with this phone number*';
    case CognitoCodes.LIMIT_EXCEEDED:
      return "You've exceeded the limit of requests, try again later";
    case CognitoCodes.CODE_MISMATCH:
      return 'Wrong confirmation code';
    default:
      return 'Something went wrong, please try again later';
  }
};
export default { CognitoCodes, getErrorMessage };
